import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-system';

export default {
    path: '/bcos/system',
    name: '系统管理',
    redirect: {
        name: `${pre}permission`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'permission',
            name: `${pre}permission`,
            meta: {
                ...meta,
                title: '权限管理',
                closable: true
            },
            component: () => import('@/bcos/views/system/permission.vue')
        },
        {
            path: 'config',
            name: `${pre}config`,
            meta: {
                ...meta,
                title: '配置管理',
                closable: true
            },
            component: () => import('@/bcos/views/system/config.vue')
        },
        {
            path: 'cert',
            name: `${pre}cert`,
            meta: {
                ...meta,
                title: '证书管理',
                closable: true
            },
            component: () => import('@/bcos/views/system/cert.vue')
        },
    ]
};
